export default __webpack_public_path__ + "static/media/back.d8c98666.svg";